module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style>.a{fill:#fff;}</style></defs><title>fb</title><circle cx=\"24.86\" cy=\"24.86\" r=\"24.14\"></circle><path class=\"a\" d=\"M27.12,39.19v-13h1.5c.83,0,1.65,0,2.48,0,.13,0,.36-.16.37-.27.23-1.59.43-3.18.64-4.83H27.18c0-1.41-.08-2.76,0-4.11a1.55,1.55,0,0,1,1.63-1.51c.77-.08,1.56-.07,2.33-.09h1.1V10.79c-.24,0-.49-.08-.73-.09a15.86,15.86,0,0,0-5.48.22A5.7,5.7,0,0,0,21.91,16c-.1,1.46-.07,2.93-.1,4.39,0,.18,0,.37,0,.6H17.46v5.09h4.32v13Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 545
// module chunks = 1